import api from '../base';
import { HoldReasonsResponse, OffersHoldRequest, OffersUnholdRequest } from './holdApiTypes';
import { mockGetHoldReasons } from './holdMock';

const BASE_PATH = 'management/products/hold';
const REASONS_PATH = `${BASE_PATH}/reasons`;

export async function holdOffers(
  request: OffersHoldRequest,
  signal?: AbortSignal,
) {
  return api.put<void>(BASE_PATH, request, { signal });
}

api.mock.onPut(BASE_PATH).reply(200);

export async function unholdOffers(
  request: OffersUnholdRequest,
  signal?: AbortSignal,
) {
  return api.delete<void>(BASE_PATH, { data: request, signal });
}

api.mock.onDelete(BASE_PATH).reply(200);

export async function getHoldReasons(
  signal?: AbortSignal,
) {
  return api.get<HoldReasonsResponse>(REASONS_PATH, { signal });
}

api.mock.onGet(REASONS_PATH).reply(200, mockGetHoldReasons);
